import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-type"]
const _hoisted_2 = { class: "cinema-teaser recommendations-teaser" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "cinema-teaser__items-container" }
const _hoisted_5 = {
  key: 0,
  class: "cinema-teaser__link"
}
const _hoisted_6 = ["href", "textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_box_slider = _resolveComponent("product-box-slider")!

  return ($setup.products && $setup.products.length > 0 || $setup.state === 'LOADING' || $setup.state === 'FALLBACK')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "data-type": $setup.type,
        class: _normalizeClass(["product-alternatives", {
      ['product-alternatives--' + $setup.state]: true,
    }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "cinema-teaser__headline | headline headline--type_h2",
            innerHTML: $setup.headline
          }, null, 8 /* PROPS */, _hoisted_3),
          _cache[0] || (_cache[0] = _createTextVNode()),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_product_box_slider, {
              class: "recommendations-tiles-teaser__products",
              products: $setup.products,
              "tracking-list": "productAlternatives",
              columns: 4
            }, null, 8 /* PROPS */, ["products"])
          ]),
          _cache[1] || (_cache[1] = _createTextVNode()),
          ($setup.linkUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("a", {
                  href: $setup.linkUrl,
                  class: "button product-alternatives__button button--secondary button--secondary-arrow",
                  textContent: _toDisplayString(_ctx.$t('ads.main.recommendation.link.winecloseness'))
                }, null, 8 /* PROPS */, _hoisted_6)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}